import React, { useState } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Mudadescricao.css';


const HEADER_HEIGHT = 56;

const Mudadescricao = ({ onProximo }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [descricao, setDescricao] = useState('');
  const LIMITE_CARACTERES = 500;

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Projetos" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-folder2-open" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Meus Projetos</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="http://localhost:3000/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-send" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Disparo 1x1</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Mudar Descrição</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "6px 16px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="#">Perfil</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Configurações</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div
        style={{
          marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
          paddingTop: HEADER_HEIGHT,
          width: window.innerWidth > 768
            ? sidebarOpen
              ? "calc(100% - 220px)"
              : "calc(100% - 70px)"
            : "100vw",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
          minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
          background: '#f7f7f7',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: 24,
          marginBottom: 32,
          paddingRight: 32,
          boxSizing: 'border-box'
        }}>
          <button
            style={{
              background: '#005c53',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 28px',
              fontWeight: 'bold',
              fontSize: 18,
              cursor: descricao && descricao.length > 0 ? 'pointer' : 'not-allowed',
              opacity: descricao && descricao.length > 0 ? 1 : 0.5,
              transition: 'opacity 0.2s',
            }}
            disabled={!descricao || descricao.length === 0}
            onClick={() => descricao && descricao.length > 0 && onProximo && onProximo(descricao)}
          >
            Próximo
          </button>
        </div>
        <textarea
          placeholder="Digite a nova descrição do grupo"
          value={descricao}
          maxLength={LIMITE_CARACTERES}
          onChange={e => {
            if (e.target.value.length <= LIMITE_CARACTERES) setDescricao(e.target.value);
          }}
          style={{
            width: '100%',
            maxWidth: 400,
            minHeight: 100,
            padding: 12,
            fontSize: 18,
            border: '1px solid #ccc',
            borderRadius: 8,
            outline: 'none',
            background: 'white',
            textAlign: 'left',
            fontWeight: 'normal',
            color: '#222',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            resize: 'vertical',
          }}
        />
        <div style={{
          width: '100%',
          maxWidth: 400,
          textAlign: 'right',
          fontSize: 14,
          color: descricao.length >= LIMITE_CARACTERES ? '#e74c3c' : '#888',
          marginTop: 4
        }}>
          {descricao.length}/{LIMITE_CARACTERES} caracteres
        </div>
      </div>
    </div>
  );
};

export default Mudadescricao;